import * as types from "../constants";

const initialState: any = {};

export default function reducer(state = initialState, actions: types.UpdateColumnDict) {
    switch (actions.type) {
        case "UPDATE_COLUMN_DICT": {
            return {
                ...state,
                ...actions.payload
            };
        }
        default:
            return state;
    }
}